import axios from "axios";

const BASE = import.meta.env.VITE_API_BASE_URL;

const apiClient = axios.create({
  baseURL: BASE,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Id": import.meta.env.VITE_CLIENT_ID,
  },
  withCredentials: true,
});

export default apiClient;
